import { POLE_ICONS } from './poleIcons'

interface PoleIconProps {
  id?: string
  size: number
}

const PoleIcon = ({ id, size }: PoleIconProps) => {
  const Icon = id ? POLE_ICONS[id] : undefined

  return Icon ? <Icon size={size} color='currentColor' /> : null
}

export default PoleIcon
